module.exports = __webpack_public_path__ + "static/media/Aakash_Gavle.10d35de8.jpg";